import { useEffect, useState } from "react";
import { Lock, UserCheck, LogIn, LogOut, ShieldCheck, AlertTriangle } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { SecureImage } from "@/components/SecureImage";
import { EmptyState } from "@/components/Badges";
import { SummaryPrefs } from "@/components/dashboard/SummaryPrefs";

const ICON: Record<string, any> = { paid: Lock, assigned: UserCheck, checkin: LogIn, checkout: LogOut, released: ShieldCheck, dispute: AlertTriangle };
const TONE: Record<string, string> = { paid: "bg-amber-100 text-amber-700", assigned: "bg-blue-100 text-blue-700", checkin: "bg-emerald-100 text-emerald-700", checkout: "bg-emerald-100 text-emerald-700", released: "bg-brand-goldSoft text-amber-800", dispute: "bg-red-100 text-red-700" };

export function Updates() {
  const [items, setItems] = useState<any[] | null>(null);
  useEffect(() => {
    const load = () => api.get("/updates").then((r) => setItems(r.data)).catch(() => setItems([]));
    load();
    const id = setInterval(load, 20000);
    return () => clearInterval(id);
  }, []);
  if (items === null) return <p className="text-sm text-brand-slate">Loading updates…</p>;
  if (items.length === 0) return <><SummaryPrefs /><EmptyState testId="updates-empty" title="No updates yet" body="Check-ins, photos and notes from your caregiver will appear here the moment they happen." /></>;

  return (
    <>
    <SummaryPrefs />
    <section className="mx-auto max-w-2xl rounded-3xl bg-[#efeae2] p-4 shadow-subtle" data-testid="updates-feed">
      <p className="mb-3 text-center text-[11px] font-semibold uppercase tracking-widest text-brand-slate">Live from Zimbabwe · refreshes every 20s</p>
      <div className="space-y-3">
        {items.map((e, i) => {
          const Icon = ICON[e.type] || Lock;
          return (
            <article key={`${e.booking_id}-${e.type}-${i}`} className="max-w-[88%] rounded-2xl rounded-tl-sm bg-white p-3 shadow-sm animate-fade-up" data-testid={`update-${e.type}`}>
              <div className="flex items-center gap-2"><span className={`flex h-7 w-7 items-center justify-center rounded-full ${TONE[e.type]}`}><Icon className="h-3.5 w-3.5" /></span><p className="text-sm font-semibold text-brand-navy">{e.title}</p></div>
              <p className="mt-1 text-xs text-brand-slate">{e.service_name} · {e.recipient_name}</p>
              {e.photo_file_id && <SecureImage fileId={e.photo_file_id} alt={e.title} className="mt-2 h-44 w-full rounded-xl object-cover" />}
              <p className="mt-2 text-sm text-brand-navy">{e.body}</p>
              <p className="mt-1 text-right text-[10px] text-brand-slate">{fmtDate(e.at)}</p>
            </article>
          );
        })}
      </div>
    </section>
    </>
  );
}
